export const ORGANIZATION_TYPES = {
  DEFAULT: 'DEFAULT',
  ATPL: 'ATP',
  HELLO_HEALTH: 'HELLO_HEALTH',
  DOKTOR_CONNECT: 'DOKTOR_CONNECT',
};

export const HEALTH_CATEGORIES = {
  OVERALL: 'Overall Health Score',
  HEART: 'Heart Health',
  BODY_FUNCTION: 'Body Function',
  PHYSICAL: 'Physical Health',
  SKIN: 'Skin Health',
  DISEASE_RISK: 'Overall Disease Risk',
  METABOLIC: 'Metabolic Health',
  PRODUCTS: 'Products',
  LAB_TESTS: 'Lab Tests',
};

export const BLUR_CATEGORIES = [
  HEALTH_CATEGORIES.PHYSICAL,
  HEALTH_CATEGORIES.SKIN,
  HEALTH_CATEGORIES.DISEASE_RISK,
  HEALTH_CATEGORIES.METABOLIC,
];

export const SLIDE_KEYS = {
  ALL_HEALTH: 'allHealth',
  HEART_HEALTH: 'heartHealth',
  BODY_FUNCTION: 'bodyFunction',
  PHYSICAL_HEALTH: 'physicalHealth',
  SKIN_HEALTH: 'skinHealth',
  DISEASE_RISK: 'diseaseRisk',
  DIABETES_RISK: 'diabetesRisk',
  PRODUCTS: 'products',
  LAB_TEST: 'labtest',
};

export const RATING_SCHEMES = {
  OPTIMAL: {color: '#A6E177', text: 'Optimal', icon: '/others/mark.svg'},
  NORMAL: {color: '#50BA47', text: 'Normal', icon: '/others/mark1.svg'},
  ELEVATED: {color: '#F2BF3A', text: 'Elevated', icon: '/others/do-not-enter.svg'},
  HIGH: {color: '#FF0000', text: 'High', icon: '/others/cross.svg'},
  LOW: {color: '#FFA500', text: 'Low', icon: '/others/do-not-enter.svg'},
};
